import React, { JSX } from 'react';
import { Button } from 'reactstrap';
import { observer } from 'mobx-react';
import DateDisplay from '../UI/DateDisplay/DateDisplay';

export interface Props {
  headline?: string;
  startDate?: string;
  endDate?: string;
  pickUpDate?: string;
  pickUpTime?: string;
  dropOffDate?: string;
  dropOffTime?: string;
  unitDescription?: string;
  locationInfo?: string;
  changeServiceLabel?: string;
  changeUnitLabel?: string;
  onShowServices?: () => void;
  onShowServiceOptions?: () => void;
}

const PackageBoxServiceInfoLayout = observer(
  (props: Props): JSX.Element => {
    const {
      headline,
      startDate,
      endDate,
      pickUpDate,
      pickUpTime,
      dropOffDate,
      dropOffTime,
      unitDescription,
      locationInfo,
      changeServiceLabel,
      changeUnitLabel,
      onShowServices,
      onShowServiceOptions
    } = props;

    return (
      <>
        <div className="d-flex flex-column h-100 small">
          <div className="font-weight-bold">{headline}</div>
          {locationInfo && <div>{locationInfo}</div>}
          {unitDescription && <div>{unitDescription}</div>}
          <div>
            {startDate && endDate && (
              <>
                <DateDisplay date={startDate} />
                {startDate !== endDate && (
                  <>
                    -
                    <DateDisplay date={endDate} />
                  </>
                )}
              </>
            )}
          </div>
          <div>
            {pickUpDate && pickUpTime && (
              <div>
                Pick-up <DateDisplay date={pickUpDate} />, {pickUpTime}
              </div>
            )}
            {dropOffDate && dropOffTime && (
              <div>
                Drop-off <DateDisplay date={dropOffDate} />, {dropOffTime}
              </div>
            )}
          </div>
          <div className="mt-auto">
            <div>
              {changeUnitLabel && onShowServiceOptions && (
                <div className="mb-2">
                  <Button
                    className="w-100"
                    color="secondary"
                    onClick={(): void => onShowServiceOptions && onShowServiceOptions()}
                  >
                    {changeUnitLabel}
                  </Button>
                </div>
              )}
            </div>
            <div>
              {changeServiceLabel && onShowServices && (
                <div className="mb-2">
                  <Button
                    className="w-100"
                    color="secondary"
                    onClick={(): void => onShowServices && onShowServices()}
                  >
                    {changeServiceLabel}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
);

export default PackageBoxServiceInfoLayout;
